import React, { FC } from 'react';
import cls from 'classnames';

import Logo from '../../../../../../../../atoms/Logo';
import { IPrizeMerchant } from '../../../../../../../../types';
import Close from '../../../../atoms/Close';

import styles from './index.module.sass';

interface HeaderProps {
  isVisible: boolean;
  merchant: IPrizeMerchant;
  onClose: () => void;
}

const Header: FC<HeaderProps> = ({
  isVisible,
  merchant: { domain, logoImageUrl, name },
  onClose,
}) => (
  <div className={cls( styles.container, { [styles.visible]: isVisible })}>
    <Logo image={logoImageUrl} link={domain} name={name} width={80} />

    <Close className={styles.close} onClick={onClose} />
  </div>
);

export default Header;
